require('./RAGoalNotification.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RACircularGoalIcon = require('../RACircularGoalIcon/RACircularGoalIcon');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const {
    GOAL_TRACKING_URL,
    RA_CANCEL_PLAN_URL,
    RA_DISASSOCIATE_GOAL_URL,
    RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE,
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
    RA_REIMBURSEMENT_URL,
} = require('../../raConstants/index');

class RAGoalNotification extends React.Component {
    buildGoalActionLinks(id, isGoalReachedBefore) {
        let conditionalLink;
        if (isGoalReachedBefore) {
            conditionalLink = (
                <OKLink
                    modifier="widget"
                    extraClass="ra-goal-notification__list-item"
                    onClick={() => {
                        this.props.onModifyAmountClick(id);
                    }}
                >
                    <FormattedText value="raGoalNotification-raGoalNotification_link3" />
                </OKLink>
            );
        }
        const disassociateGoalURL = `${RA_DISASSOCIATE_GOAL_URL}/${id}`;
        const reimbursementLink = `${RA_REIMBURSEMENT_URL}/${id}`;
        const cancelPlanURL = `${RA_CANCEL_PLAN_URL}/${id}`;
        const secondLinkURL = isGoalReachedBefore
            ? reimbursementLink
            : cancelPlanURL;
        const secondLinkNumberKey = isGoalReachedBefore ? 2 : 4;
        const secondLinkInfoKey = `raGoalNotification-raGoalNotification_link${secondLinkNumberKey}`;

        return (
            <div className="ra-goal-notification__list">
                <OKLink
                    to={disassociateGoalURL}
                    modifier="widget"
                    extraClass="ra-goal-notification__list-item"
                >
                    <FormattedText value="raGoalNotification-raGoalNotification_link1" />
                </OKLink>
                <OKLink
                    to={secondLinkURL}
                    modifier="widget"
                    extraClass="ra-goal-notification__list-item"
                >
                    <FormattedText value={secondLinkInfoKey} />
                </OKLink>
                {conditionalLink}
            </div>
        );
    }

    buildGoalLink(immGoal, isFromMultple) {
        const { showGoalLink } = this.props;
        const id = immGoal.get('id');
        const name = immGoal.getIn(['goalInformation', 'name']);
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const formattedGoalDate = moment(goalDate).format('MMM YYYY');
        const url = `${GOAL_TRACKING_URL}/${id}`;
        let content;
        if (isFromMultple) {
            content = ` (${formattedGoalDate})`;
        }

        let goalText;

        if (showGoalLink) {
            goalText = (
                <OKLink modifier="inline" inverse={true} to={url}>
                    {name}
                </OKLink>
            );
        } else {
            goalText = (
                <span className="ra-goal-notification__goal-name">{name}</span>
            );
        }

        return (
            <div className="ra-goal-notification__multiple-link-wrapper">
                {goalText}
                {content}
            </div>
        );
    }

    buildGoalInfoContent(immGoal) {
        const goalProgress = immGoal.getIn(['goalInformation', 'goalProgress']);
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const formattedGoalDate = moment(goalDate).format('MMM YYYY');
        const goalLink = this.buildGoalLink(immGoal);
        let firstLineInfoKey;

        if (goalProgress >= 1) {
            const isGoalReachedBefore = moment(goalDate).isAfter(
                moment(),
                'day',
            );
            const infoNumberKey = isGoalReachedBefore ? 7 : 8;
            firstLineInfoKey = `raGoalNotification-raGoalNotification_singleGoalInfo${infoNumberKey}`;
        } else {
            firstLineInfoKey =
                'raGoalNotification-raGoalNotification_singleGoalInfo6';
        }

        return (
            <FormattedTextWithComponents
                value={firstLineInfoKey}
                injectedComponents={[goalLink, formattedGoalDate]}
                className="ra-goal-notification__info-text"
            />
        );
    }

    buildSingleGoalNotification(immGoal) {
        const id = immGoal.get('id');
        const goalName = immGoal.getIn(['goalInformation', 'name']);
        const goalType = immGoal.getIn(['goalInformation', 'goalType']);
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const goalProgress = immGoal.getIn(['goalInformation', 'goalProgress']);

        let title;
        let secondLineInfo;
        let thirdLineInfo;
        let actionLinks;
        let modifier;

        if (goalProgress >= 1) {
            const isGoalReachedBefore = moment(goalDate).isAfter(
                moment(),
                'day',
            );
            const infoNumberKey = isGoalReachedBefore ? 2 : 5;
            const secondLineInfoKey = `raGoalNotification-raGoalNotification_singleGoalInfo${infoNumberKey}`;
            title = formatText(
                'raGoalNotification-raGoalNotification_singleGoalTitle',
                [goalName],
            );
            secondLineInfo = (
                <FormattedText
                    value={secondLineInfoKey}
                    className="ra-goal-notification__info-text"
                />
            );
            thirdLineInfo = (
                <FormattedText value="raGoalNotification-raGoalNotification_singleGoalInfo3" />
            );
            actionLinks = this.buildGoalActionLinks(id, isGoalReachedBefore);
            modifier = RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS;
        } else {
            const disassociateGoalURL = `${RA_DISASSOCIATE_GOAL_URL}/${id}`;
            title = formatText(
                'raGoalNotification-raGoalNotification_singleGoalTitle2',
                [goalName],
            );
            secondLineInfo = (
                <FormattedText
                    value="raGoalNotification-raGoalNotification_singleGoalInfo5"
                    className="ra-goal-notification__info-text"
                />
            );
            actionLinks = (
                <OKLink
                    to={disassociateGoalURL}
                    modifier="widget"
                    extraClass="ra-goal-notification__list-item"
                >
                    <FormattedText value="raGoalNotification-raGoalNotification_link5" />
                </OKLink>
            );
            modifier = RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
        }

        const infoContent = this.buildGoalInfoContent(immGoal);

        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                title={title}
                closeButton={true}
                customIcon={
                    <RACircularGoalIcon type={goalType} modifier={modifier} />
                }
                onCloseButtonClick={this.props.onClose}
            >
                <div className="ra-goal-notification__info">
                    {infoContent}
                    {secondLineInfo}
                    {thirdLineInfo}
                </div>
                {actionLinks}
            </OKMessage>
        );
    }

    buildMultipleGoalLinks(immGoals) {
        if (immGoals.size === 1) {
            return this.buildGoalLink(immGoals.first(), true);
        } else {
            const initialLinks = this.buildMultipleGoalLinks(
                immGoals.slice(0, immGoals.size - 1),
            );
            const lastLink = this.buildGoalLink(immGoals.last(), true);
            return (
                <FormattedTextWithComponents
                    value="raGoalNotification-raGoalNotification_multipleInitialLinks"
                    injectedComponents={[initialLinks, lastLink]}
                />
            );
        }
    }

    buildGoalsContent(immGoals, translationKey) {
        let goalsContent;
        if (immGoals.size === 1) {
            const immGoal = immGoals.first();
            goalsContent = this.buildGoalInfoContent(immGoal);
        } else if (immGoals.size > 1) {
            const immPartialsGoals = immGoals.slice(0, immGoals.size - 1);
            const immLastGoal = immGoals.last();
            const initialLinks = this.buildMultipleGoalLinks(immPartialsGoals);
            const lastLink = this.buildGoalLink(immLastGoal, true);
            const allLinks = (
                <FormattedTextWithComponents
                    value="raGoalNotification-raGoalNotification_multipleLastLink"
                    injectedComponents={[initialLinks, lastLink]}
                />
            );

            goalsContent = (
                <FormattedTextWithComponents
                    value={translationKey}
                    injectedComponents={[allLinks]}
                    className="ra-goal-notification__info-text"
                />
            );
        }

        return goalsContent;
    }

    buildMultipleGoalsNotification(immGoals) {
        const immGoalsReachedBeforeDate = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress >= 1 && moment(goalDate).isAfter(moment(), 'day')
            );
        });
        const immGoalsReachedOnDate = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress >= 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const immGoalsNonReached = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const beforeDateTranslationKey =
            'raGoalNotification-raGoalNotification_multipleGoalInfo1';
        const onDateTranslationKey =
            'raGoalNotification-raGoalNotification_multipleGoalInfo2';
        const nonReachedTranslationKey =
            'raGoalNotification-raGoalNotification_multipleGoalInfo4';
        const goalsReachedBeforeDateContent = this.buildGoalsContent(
            immGoalsReachedBeforeDate,
            beforeDateTranslationKey,
        );
        const goalsReachedOnDateContent = this.buildGoalsContent(
            immGoalsReachedOnDate,
            onDateTranslationKey,
        );
        const goalsNonReached = this.buildGoalsContent(
            immGoalsNonReached,
            nonReachedTranslationKey,
        );
        let title = formatText(
            'raGoalNotification-raGoalNotification_multipleGoalTitle',
        );
        let modifier = RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS;
        if (immGoalsNonReached.size >= 1) {
            title = formatText(
                'raGoalNotification-raGoalNotification_multipleGoalTitle2',
            );
            if (
                immGoalsReachedBeforeDate.size >= 1 ||
                immGoalsReachedOnDate.size >= 1
            ) {
                modifier = RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE;
            } else {
                modifier = RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
            }
        }

        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                title={title}
                closeButton={true}
                customIcon={<RACircularGoalIcon modifier={modifier} />}
                onCloseButtonClick={this.props.onClose}
            >
                <div className="ra-goal-notification__info">
                    {goalsReachedBeforeDateContent}
                    {goalsReachedOnDateContent}
                    {goalsNonReached}
                    <FormattedText value="raGoalNotification-raGoalNotification_multipleGoalInfo3" />
                </div>
            </OKMessage>
        );
    }

    render() {
        const { immGoals } = this.props;
        const immActiveGoals = immGoals.filter(immGoal => {
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalReached = goalProgress >= 1;
            const goalNotReached =
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day');

            return (
                (goalReached || goalNotReached) &&
                !immGoal.getIn(['state', 'cancelled'])
            );
        });
        let content = null;

        if (immActiveGoals.size === 1) {
            const immGoal = immActiveGoals.first();
            content = this.buildSingleGoalNotification(immGoal);
        } else if (immActiveGoals.size > 1) {
            content = this.buildMultipleGoalsNotification(immActiveGoals);
        }

        return content;
    }
}

RAGoalNotification.propTypes = {
    immGoals: PropTypes.object.isRequired,
    onModifyAmountClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    showGoalLink: PropTypes.bool.isRequired,
};

RAGoalNotification.defaultProps = {
    showGoalLink: true,
};

module.exports = RAGoalNotification;
